import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { LocaleService } from '@app/core/i18n';
import { ProductReservation, Product } from '@vestiaire/api-sdk-angular';
import { ReservationService } from '@app/shared/services/product';
import { Subscription } from 'rxjs';

import * as fromProduct from '@app/+product/store/reducers';

export interface AddToCartModalData {
  error?: boolean;
  errorMessage?: string;
  product?: Product;
}

@Component({
  selector: 'vc-add-to-cart-modal',
  templateUrl: './add-to-cart-modal.component.html',
  styleUrls: ['./add-to-cart-modal.component.scss']
})
export class AddToCartModalComponent implements OnInit, OnDestroy {
  public error = false;
  public errorMessage: string | null;
  public product: Product;

  public displayTaxes = false;

  public reservation: ProductReservation | null;
  public reservationExpirationDate: Date | null;
  private reservationSubscription: Subscription;

  constructor(
    private store$: Store<IAppState>,
    @Inject(MAT_DIALOG_DATA) public data: AddToCartModalData,
    public dialogRef: MatDialogRef<AddToCartModalComponent>,
    private reservationService: ReservationService,
    private localeService: LocaleService
  ) {
    this.displayTaxes = this.localeService.shouldDisplayTaxes();
  }

  ngOnInit() {
    this.error = this.data.error;
    this.errorMessage = this.data.errorMessage;
    this.product = this.data.product;

    this.initReservation();
  }

  ngOnDestroy(): void {
    this.reservationSubscription.unsubscribe();
  }

  setReservation(reservation?: ProductReservation): void {
    let expiresAt = null;

    if (reservation && reservation.expirationDate) {
      expiresAt = new Date(reservation.expirationDate);
    }

    this.reservation = reservation;
    this.reservationExpirationDate = expiresAt;
  }

  initReservation() {
    this.reservationSubscription = this.store$.pipe(select(fromProduct.selectReservationState)).subscribe(
      state => {
        const reservation = state && state.productId === this.product.id ? state.status : null;
        this.setReservation(reservation);
      },
      error => this.setReservation()
    );
  }

  get isReserved(): boolean {
    return this.reservation && this.reservationService.isValid(this.reservation);
  }

  closePopin() {
    this.dialogRef.close();
  }
}
